import { useCurrentUser } from '@mp/hooks';
import { useWorkHistoryForWorkExperience } from '../graphql';
import { validateExperience, ValidationResult } from './validateExperience';

type UseValidationProps = {
  startDate?: Date;
  endDate?: Date;
  currentlyWorkHere?: boolean;
};

export const useExperienceValidationFromContext = ({
  startDate,
  endDate,
  currentlyWorkHere,
}: UseValidationProps = {}): ValidationResult => {
  const { currentUser } = useCurrentUser();
  const { workHistories } = useWorkHistoryForWorkExperience();

  return validateExperience(workHistories, currentUser, {
    startDate,
    endDate,
    currentlyWorkHere,
  });
};
